import {
  ApartmentCategoryEnum,
  HouseCategoryEnum,
  LandCategoryEnum,
  OfficeCategoryEnum,
} from "@/types/types";
import styles from "../page-searchbar.module.css";
import { IoIosArrowDown } from "react-icons/io";

export default function CategorySelectorServer({
  t,
  activeCategory,
}: {
  t: any;
  activeCategory:
    | ApartmentCategoryEnum
    | HouseCategoryEnum
    | LandCategoryEnum
    | OfficeCategoryEnum
    | null;
}) {
  return (
    <div className={`${styles.selectWrapper} ${styles.typeItemWrapper}`}>
      <button className={styles.pill}>
        <div className={styles.textWrapper}>
          <span>
            {activeCategory !== null && activeCategory !== undefined
              ? t(activeCategory)
              : t("categoryTitle")}
          </span>
        </div>
        <span className={styles.chevron}>
          <IoIosArrowDown />
        </span>
      </button>
    </div>
  );
}
